import YouTubePlay from './components/YouTubePlay';

function App() {
  return <YouTubePlay />
}

export default App;